<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <CAlert color="info" class="mb-4 mt-3">
                         This report shows listing of core teams of department.
                        </CAlert>
                        <Datatable 
                            :items="items" 
                            :depart="depart"
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @department_filter="handleDepartmentFilter"
                            :btn_show="false"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_hod_report.vue' 
import axios from 'axios';
import report from '@/services/report';
import department from '@/services/department';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

import Multiselect from 'vue-multiselect'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable,  alertmodal,Multiselect },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      updateSubmit: false,
      fields: [
          {key: 'firstname', sortable: false},
          {key: 'profilepic', sortable: false},
          {key: 'department', sortable: false},
          {key: 'email', sortable: false},
          {key: 'mobile_phone', sortable: false},
          {key: 'address1', sortable: false},
          {key: 'dob', sortable: false},
      ],
      items: [],
      depart: [],
      options_member:[],
      options_service:[],
      options_keperluan: [], 
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 0,
      department_id: 0,
    }
   },
    created() {
     
  },

   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        department_id: this.department_id,
      }
      report.getDepartmentCoreTeamReport(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          this.depart = res.department
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,
              department_id: res.department_id
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },
    handleDepartmentFilter(val) {
        this.department_id = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleGrantWebAccess(val) {
      if(confirm("Do you really want to grant web access?")){
        member.grantwebaccess(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }   
    },
    handleResetPassword(val) {
      if(confirm("Do you really want to reset password?")){
        member.resetpassword(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }       
    },    

  }
  
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
